<script>
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: ['item', 'voucher', 'vouchers', 'buttonurl'],

        data() {
            return {
                fetch: new Form({
                    buyable_type: null,
                    course_id: null,
                }),
                form: null,
                loadingQuota: false,
                gift_recipient: {
                    sender_name: "",
                    message: "Spero che questo regalo ti piaccia. Scopri la tua passione sportiva!",
                    email: "",
                    name: ""
                },
                gift_id: this.item.buyable_id,
                detail: null
            }
        },
        watch: {
            'item.is_gift': function (value) {
                if (value) {
                    this.$bus.$emit('remove_all_cart_elements_except_gift', this.item)
                } else {
                    this.$set(this, 'gift_recipient', {
                        email: "",
                        name: "",
                        sender_name: "",
                        message: "Spero che questo regalo ti piaccia. Scopri la tua passione sportiva!"
                    })
                }

                this.$bus.$emit('update-gift-status', value)
            },
            'gift_recipient': {
                handler(value) {
                    this.$bus.$emit('update-recipient-data', value)
                },
                deep: true
            },
        },
        computed: {
            groupedByAgeRange() {
                if (this.item.buyable_type === 'App\\SummerCampProduct') {
                    return _.groupBy(this.detail.buyable.compose_formula_settings, 'age_range')
                }

                return []
            }
        },
        mounted() {
            this.$bus.$on('validation-fails', this.setValidationErrors)
            this.getCartElementDetail()
        },
        methods: {
            async getCartElementDetail() {
                if (this.item.buyable_type === 'App\\SummerCampProduct') {
                    await this.fetch
                        .get(route('summer_camps.product_detail', this.item.buyable_id))
                        .then(response => {
                            this.$set(this, 'detail', Object.assign(this.item, {
                                summer_camp: response.summerCamp
                            }))
                        })
                        .catch(error => console.log(error))
                } else if (this.item.buyable_type === 'App\\CompanyFee') {
                    this.$set(this.fetch, 'course_id', this.item.course_id)

                    await this.fetch
                        .get(route('company_fee.get', this.item.buyable_id))
                        .then(response => {
                            this.$set(this, 'detail', Object.assign(this.item, {
                                course: response.course,
                                company: response.company
                            }))
                        })
                        .catch(error => console.log(error))
                } else {
                    if (!this.item.buyable.hasOwnProperty('course')) {
                        this.$set(this.fetch, 'buyable_type', this.item.buyable_type)

                        await this.fetch
                            .get(route('course.get', this.item.buyable_id))
                            .then(response => {
                                this.$set(this, 'detail', Object.assign(this.item, {
                                    course: response.course
                                }))
                            })
                            .catch(error => console.log('error', error))
                    } else {
                        this.$set(this, 'detail', Object.assign(this.item, {
                            course: this.item.buyable.course
                        }))
                    }        
                }
            },
            setValidationErrors({form}) {
                this.$set(this, 'form', form)
            },
            isFee({buyable_type}) {
                return buyable_type === "App\\CompanyFee"
            },
            isSubscription({buyable_type}) {
                return buyable_type === "App\\CourseSubscription"
            },
            isLessonPackage({buyable_type}) {
                return buyable_type === "App\\LessonPackage"
            },
            isPromotion({buyable_type}) {
                return buyable_type === "App\\CoursePromotion"
            },
            getPromoDescription({buyable}) {
                let textType = buyable.lesson_type == 'group' ? 'di gruppo' : 'individuali'
                let people = buyable.people > 1 ? 'persone' : 'persona'
                return `${buyable.lessons} lezioni ${textType} per ${buyable.people} ${people}`
            },
            remove(element, elementType, index) {
                let self = this;
                let elementId = null;
                if (element.id)
                    elementId = element.id
                else
                    elementId = element.session_id
                bootbox.confirm({
                    message: "Sei sicuro di voler eliminare questo elemento dal carrello?.",
                    buttons: {
                        cancel: {
                            label: 'No'
                        },
                        confirm: {
                            label: 'Ok',
                            className: 'btn-primary'
                        }
                    },
                    callback: (result) => {
                        if (result) {
                            axios({
                                method: 'delete',
                                url: '/carts/' + elementId
                            }).then((response) => {
                                // this.$bus.$emit('cart-element-removed', elementId);
                                // this.$emit('delete-item', { item: this.item })
                                this.$emit('update-items', {items: response.data});
                                this.$bus.$emit('cart-element-update', response.data);
                            }).catch((error) => {
                                this.$emit('init-error', 'Delete failed');
                            });
                        }
                    }
                });
            },
            getCourseThumbImage(element) {
                if (element.buyable.hasOwnProperty('course')) {
                    if (element.buyable.course.course_thumb_image) {
                        return element.buyable.course.course_thumb_image
                    }
                    return element.buyable.course.sport.course_cover_image;
                } else if (element.hasOwnProperty('course')) {
                    if (element.course.course_thumb_image) {
                        return element.course.course_thumb_image_full
                    }
                    return element.course.sport.course_cover_image;
                }
            },
            getSummerCampThumbImage(element) {
                if (element.hasOwnProperty('summer_camp')) {
                    if (element.summer_camp.summer_camp_cover_image) {
                        return element.summer_camp.summer_camp_cover_image
                    }
                }
            },
            switchMembershipFee(cart_element) {
                this.loadingQuota = true;
                var self = this;
                let company = null

                if (cart_element.with_membership_fee) {
                    if (this.detail.hasOwnProperty('course')) {
                        company = this.detail.course.company.name
                    } else if (this.detail.hasOwnProperty('summer_camp')) {
                        company = this.detail.summer_camp.company.name
                    }
                    bootbox.dialog({
                        title: `<div class="bootbox-modal-title"><p>Sei già iscritto a ${company}?</p></div>`,
                        message: "<p>Dichiaro di essere associato/tesserato e di non dover rinnovare la quota associativa o di tesseramento</p>",
                        closeButton: true,
                        backdrop: 'static',
                        onEscape: function() {
                           self.$set(self.detail, 'with_membership_fee', self.detail.with_membership_fee == 1 ? 0 : 1)
                        },
                        buttons: {
                            confirm: {
                                label: 'Sono associato',
                                className: "text-center fw-600 mx-auto btn-primary text-uppercase",
                                callback: function (result) {
                                    let $button = $(this).find('button.btn-primary')
                                    let $closeButton = $(this).find('button.close')

                                    $button.prop('disabled', true)
                                    $closeButton.prop('disabled', true)

                                    self
                                        .setPromotionFeeActive(cart_element, 0)
                                        .then(response => {
                                            $button.prop('disabled', false)
                                            $closeButton.prop('disabled', false)

                                            bootbox.hideAll()
                                        }).catch(error => {
                                            $button.prop('disabled', false)
                                            $closeButton.prop('disabled', false)
                                        })
                                    return false
                                },
                            },
                            cancel: {
                                className: "hidden"                              
                            }
                        },                      
                    });

                    $('.modal-dialog').addClass('modal-dialog-centered');
                } else {
                    this
                        .setPromotionFeeActive(cart_element, 1)
                        .then(response => {
                            if (this.detail) {
                                this.detail.with_membership_fee = 1
                            } else if (this.item) {
                                this.item.with_membership_fee = 1
                            }

                            this.$emit('update-item', {item: cart_element, active: 1})
                        });
                }
            },
            setPromotionFeeActive(cart_element, active) {
                let self = this;
                return new Promise((resolve, reject) => {
                    axios({
                        method: 'post',
                        url: '/carts/switchMembershipFee',
                        data: {
                            cartElement: cart_element
                        }
                    }).then((response) => {
                        this.$emit('update-item', {item: response.data.cartElement, active})
                        self.loadingQuota = false;

                        resolve({item: response.data.cartElement, active})
                    }).catch((error) => {
                        self.$emit('init-error', 'Switch fallito');
                        self.loadingQuota = false;

                        reject('Switch fallito')
                    })
                })
            },
            giftCardAmount({buyable}) {
                return buyable.voucher.price
            },
            giftCardImage(item) {
                return `/${item.gift_card_image}`;
            },
            getTotalMembershipFee(element) {
                if (element.buyable_type == 'App\\SummerCampProduct') {
                    if (element.with_membership_fee) {
                        return parseFloat(element.buyable.membership_fee);
                    }
                    return 0;
                }
                return parseFloat(element.buyable.n_partecipants * element.buyable.membership_fee);
            },
            toggleSummerCampProductMembershipFee() {
                let element = this.detail

                this.switchMembershipFee(element)
            },
            getProductTotalWithMembershipFee(element) {
                if (element.with_membership_fee) {
                    if (element.buyable_type == 'App\\SummerCampProduct') {
                        return parseFloat(element.buyable.price_final_with_discount) + this.getTotalMembershipFee(element)
                    } else {
                        if (element.buyable.fee) {
                            return parseFloat(element.buyable.price) + element.buyable.fee.price
                        } else if (element.course && element.course.membership_fee) {
                            return parseFloat(element.buyable.price) + element.course.membership_fee
                        }
                    }
                }

                if (element.buyable_type == 'App\\SummerCampProduct') {
                    if (element.buyable.summer_camp.membership_fee_type == 'counted') {
                        return parseFloat(element.buyable.price_final_with_discount) + this.getTotalMembershipFee(element)
                    }
                    return parseFloat(element.buyable.price_final_with_discount)
                } else {
                    return parseFloat(element.buyable.price)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/cart/CartElement.vue